import { createSlice } from '@reduxjs/toolkit';
import { API_STATUS } from 'constants/constants';

const INIT = {
  isAuthenticated: false,
  roles: [],
  permissions: [],
  username: '',
  userId: '',
  firstname: '',
  lastname: '',
  email: '',
  error: '',
  status: API_STATUS.IDLE,
  oauthGoogle: API_STATUS.IDLE,
  use2Fa: false,
  register: {
    status: API_STATUS.IDLE,
  },
};

const auth = createSlice({
  name: 'auth',
  initialState: INIT,
  reducers: {
    authenticateSuccess(state, action) {
      const { payload = {} } = action;
      state = {
        ...INIT,
        ...payload,
        isAuthenticated: true,
        status: API_STATUS.SUCCESS,
      };

      return state;
    },
    authenticateFail(state, action) {
      const { payload } = action;
      state = {
        ...INIT,
        error: payload,
        status: API_STATUS.ERROR,
      };

      return state;
    },
    authenticationTwoFa(state) {
      return {
        ...state,
        use2Fa: true,
        status: API_STATUS.SUCCESS,
      };
    },
    verifyTwoFa(state) {
      return { ...state };
    },
    verifyTwoFaFail(state, action) {
      const { payload } = action;
      return {
        ...state,
        error: payload,
        status: API_STATUS.ERROR,
      };
    },
    enable2Fa(state) {
      return { ...state, use2Fa: true };
    },
    disable2Fa(state) {
      return { ...state, use2Fa: false };
    },
    logout(state, action) {
      return state;
    },
    logOutSuccess(state, action) {
      localStorage.clear();
      window.history.replaceState({}, null, '/auth');
      window.location.reload();
      return state;
    },
    login(state, action) {
      state = {
        ...INIT,
        status: API_STATUS.PROCESSING,
      };

      return state;
    },
    cancelLogin(state) {
      return {
        ...INIT,
      };
    },
    registerRequest(state) {
      state = {
        ...INIT,
        register: {
          status: API_STATUS.PROCESSING,
        },
      };
      return state;
    },
    registerSuccess(state) {
      state = {
        ...INIT,
        register: {
          status: API_STATUS.SUCCESS,
        },
      };

      return state;
    },
    registerError(state, action) {
      const { payload } = action;
      state = {
        ...INIT,
        register: {
          status: API_STATUS.ERROR,
          error: payload,
        },
      };

      return state;
    },
    cancelRegister(state) {
      return { ...INIT };
    },
    setUserInfo(state, action) {
      const { payload } = action;
      state = {
        ...state,
        ...payload,
        isAuthenticated: true,
      };

      return state;
    },
    regenerateKey(state, action) {
      const { payload } = action;
      state = {
        ...state,
        keys: payload,
      };
      return state;
    },
    registerSubAccountRequest(state, action) {
      state.register.status = API_STATUS.PROCESSING;
      state.register.error = null;
      return state;
    },
    registerSubAccountError(state, action) {
      state.register.status = API_STATUS.ERROR;
      state.register.error = action.payload;
      return state;
    },
    registerSubAccountSuccess(state, action) {
      state.register.status = API_STATUS.SUCCESS;
      return state;
    },
    forgotPasswordRequest(state, action) {
      state.status = API_STATUS.PROCESSING;
      return state;
    },
    forgotPasswordError(state, action) {
      state.error = action.payload;
      state.status = API_STATUS.ERROR;
      return state;
    },
    forgotPasswordSuccess(state, action) {
      state.status = API_STATUS.SUCCESS;
      return state;
    },
    resetPasswordRequest(state, action) {
      state.status = API_STATUS.PROCESSING;
      return state;
    },
    resetPasswordError(state, action) {
      state.status = API_STATUS.ERROR;
      state.error = action.payload;
      return state;
    },
    resetPasswordSuccess(state, action) {
      state.status = API_STATUS.SUCCESS;
      return state
    },
    oauthGoogle(state, action) {
      state.oauthGoogle = API_STATUS.PROCESSING;
      return state;
    }
  },
});

export const {
  regenerateKey,
  authenticateSuccess,
  authenticateFail,
  login,
  logout,
  registerError,
  registerSuccess,
  registerRequest,
  cancelLogin,
  cancelRegister,
  setUserInfo,
  logOutSuccess,
  authenticationTwoFa,
  verifyTwoFa,
  verifyTwoFaFail,
  enable2Fa,
  disable2Fa,
  registerSubAccountError,
  registerSubAccountRequest,
  registerSubAccountSuccess,
  forgotPasswordError,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  resetPasswordError,
  resetPasswordRequest,
  resetPasswordSuccess,
  oauthGoogle
} = auth.actions;

export default auth.reducer;
